import { AnimatePresence, motion } from "framer-motion";

interface GiftModalProps {
  onClose: () => void;
}

const GiftModal = ({ onClose }: GiftModalProps) => {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => onClose()}
      >
        <motion.div
          className="w-[340px] md:w-lg min-h-[445px] rounded-2xl shadow-lg p-6 flex flex-col justify-center
                     bg-[linear-gradient(to_bottom,_#54C6F9,_#A36AFF)] text-white"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ type: "spring", duration: 0.4 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-center flex-col gap-5 text-center">
            <img
              src="/images/eid_mobarak.png"
              alt="gift"
              width={177}
              height={131}
            />
            <p className="text-3xl font-kalameh">
              دمت گرم که تا اینجا باهامون همراه بودی و تبریک!
            </p>
            <p className="text-lg font-kalameh">
              اسمت توی قرعه کشی کربلا ثبت شد. آخر ماه بین همه قرعه کشی میشه و
              برنده از طریق پیامک اطلاع رسانی میشه
            </p>
            <button
              className="bg-[#54C6F9] text-lg font-kalameh py-2 px-10 text-center rounded-4xl"
              onClick={onClose}
            >
              درس بعدی
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default GiftModal;
